import { useState } from 'react';

const scenarios = [
  {
    id: 'guzellik',
    label: 'Güzellik Merkezi',
    icon: 'ri-heart-pulse-line',
    description:
      'Randevu talepleri, kampanya dönüşleri, işlem ilgisi, tekrar aranacak kişiler, gelmeyen randevular ve müşteri memnuniyeti takip edilebilir.',
  },
  {
    id: 'egitim',
    label: 'Eğitim Kurumu',
    icon: 'ri-graduation-cap-line',
    description:
      'Başvuru, görüşme, kayıt, ödeme, belge programı ilgisi, tekrar aranacak adaylar ve kayıt süreci takip edilebilir.',
  },
  {
    id: 'servis',
    label: 'Servis Firması',
    icon: 'ri-tools-line',
    description:
      'Arıza talepleri, bakım zamanı, ödeme durumu, tekrar aranacak müşteriler ve servis süreci takip edilebilir.',
  },
  {
    id: 'saglik',
    label: 'Sağlık / Klinik',
    icon: 'ri-stethoscope-line',
    description:
      'Bilgi talepleri, ön görüşme, randevu takibi, işlem ilgisi ve danışan süreci düzenli şekilde yönetilebilir.',
  },
  {
    id: 'gayrimenkul',
    label: 'Gayrimenkul',
    icon: 'ri-building-4-line',
    description:
      'Alıcı, satıcı, yatırımcı, kiralama talebi, portföy ilgisi ve tekrar iletişim kurulacak kişiler ayrıştırılabilir.',
  },
  {
    id: 'yerel',
    label: 'Yerel Hizmet Firmaları',
    icon: 'ri-store-2-line',
    description:
      'Reklamdan gelen tüm talepler daha düzenli takip edilerek satışa yakın kişilere öncelik verilebilir.',
  },
];

export default function ScenariosSection() {
  const [active, setActive] = useState(scenarios[0].id);
  const current = scenarios.find((s) => s.id === active) || scenarios[0];

  return (
    <section className="py-16 md:py-24 bg-background-50" id="senaryolar">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Hangi İşlerde Nasıl Kullanılabilir?
          </h2>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2 mb-8">
          {scenarios.map((s) => (
            <button
              key={s.id}
              onClick={() => setActive(s.id)}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                active === s.id
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              <i className={`${s.icon} text-base`}></i>
              {s.label}
            </button>
          ))}
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-2xl bg-background-100 border border-background-200/50 p-6 md:p-8 text-center">
            <div className="w-14 h-14 rounded-2xl bg-accent-100 flex items-center justify-center mx-auto mb-4">
              <i className={`${current.icon} text-accent-600 text-2xl`}></i>
            </div>
            <h3 className="font-heading font-bold text-foreground-900 text-xl mb-3">
              {current.label}
            </h3>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto">
              {current.description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}